import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { CommentPublisherResult } from '../CommentEditor/redux/types';
import { Thread, StreamChangedConfig } from './types';
import { PapiCommentThread, PapiDeviation } from '@wix/da-papi-types';
import { getStreamId } from './helpers';
import { getCommentableTypeForDeviationType } from '../DeviationPage/redux/helpers';
import { createCallbackActionCreator } from '../Stream/helpers';

export const initializeThread = createAction(
  `${actionTypePrefix}/INITIALIZE`,
  ({
    thread,
    maxDepth,
    itemsPerFetch,
  }: {
    thread: Thread;
    maxDepth?: number;
    itemsPerFetch?: number;
  }) => ({
    thread,
    maxDepth,
    itemsPerFetch,
  })
);

export const initializeThreadFromPapi = ({
  hasMore,
  hasLess,
  thread,
  total,
  canPostComment,
  commentableItemid,
  commentableTypeid,
  cursor,
  prevCursor,
}: PapiCommentThread) =>
  initializeThread({
    thread: {
      commentableItemId: commentableItemid,
      commentableTypeId: commentableTypeid,
      hasMore,
      hasLess,
      items: thread,
      total,
      canPostComment,
      cursor: cursor || undefined,
      prevCursor: prevCursor || undefined,
    },
  });

export const initializeEmptyThread = (
  commentableItemId: number,
  commentableTypeId: number
) =>
  initializeThread({
    thread: {
      commentableItemId,
      commentableTypeId,
      hasMore: false,
      hasLess: false,
      items: [],
      total: 0,
      canPostComment: false,
    },
  });

export const streamIdChanged = createAction(
  `${actionTypePrefix}/STREAM_ID_CHANGED`,
  (config: StreamChangedConfig) => config
);

export const changeOrder = createAction(
  `${actionTypePrefix}/CHANGE_ORDER`,
  (streamId, order) => {
    return { order, streamId };
  }
);

export const threadUpdated = createAction(
  `${actionTypePrefix}/THREAD_UPDATED`,
  (streamId, result: CommentPublisherResult) => {
    return { streamId, result };
  }
);

export const deviationThreadUpdated = (
  deviation: PapiDeviation,
  result: CommentPublisherResult
) =>
  threadUpdated(
    getStreamId(
      getCommentableTypeForDeviationType(deviation),
      deviation.deviationId
    ),
    result
  );

export const fetchNextInThread = createCallbackActionCreator(
  `${actionTypePrefix}/THREAD_FETCH_NEXT`
);

export const fetchPreviousInThread = createCallbackActionCreator(
  `${actionTypePrefix}/THREAD_FETCH_PREV`
);
